import { faKey, faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import getCoreLoginStore from "../../stores/core/core-login-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import {
  PROFILE_ACTION_FONT_SIZE,
  PROFILE_ACTION_GAP,
  PROFILE_ACTION_HEIGHT,
  PROFILE_ACTION_ICON_SIZE,
  PROFILE_ACTION_RADIUS,
  PROFILE_DANGER_BACKGROUND,
  PROFILE_DANGER_HOVER,
  PROFILE_SECONDARY_BORDER,
  PROFILE_SECONDARY_HOVER,
  PROFILE_TRANSITION
} from "./profile-dropdown-constants";

const CHANGE_PASSWORD_PATH = "/CSR/changePassword";

const ProfileAction = withLiteObserverAndTheme<{
  icon: typeof faKey;
  label: string;
  labelColor: string;
  restingBackground: string;
  hoverBackground: string;
  border: string;
  onPress: () => void;
}>((props) => {
  const {
    icon,
    label,
    labelColor,
    restingBackground,
    hoverBackground,
    border,
    onPress,
    theme
  } = props;
  const { unitX, unitY } = theme;
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => onPress()}
      style={{
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: PROFILE_ACTION_HEIGHT * unitY,
        border,
        cursor: "pointer",
        backgroundColor: isHovered ? hoverBackground : restingBackground,
        borderRadius: PROFILE_ACTION_RADIUS * unitX,
        gap: PROFILE_ACTION_GAP * unitX,
        transition: PROFILE_TRANSITION
      }}
    >
      <FontAwesomeIcon
        icon={icon}
        color={labelColor}
        style={{
          width: PROFILE_ACTION_ICON_SIZE * unitX,
          height: PROFILE_ACTION_ICON_SIZE * unitY,
          flexShrink: 0
        }}
      />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={PROFILE_ACTION_FONT_SIZE}
        text={label}
        isSpan={false}
        color={labelColor}
        style={{ margin: 0, whiteSpace: "nowrap" }}
      />
    </button>
  );
});

const ProfileDropdownButtons = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitY } = theme;
  const navigate = useNavigate();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="stretch"
      withShadow={false}
      width={0}
      height={0}
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        gap: PROFILE_ACTION_GAP * unitY
      }}
      onClick={() => {}}
    >
      <ProfileAction
        icon={faKey}
        label={i18n.get("CHANGE_PASSWORD")}
        labelColor={colors.all.maastrichtBlue}
        restingBackground={colors.all.transparent}
        hoverBackground={PROFILE_SECONDARY_HOVER}
        border={PROFILE_SECONDARY_BORDER}
        onPress={() => {
          getCoreUIStore().isProfileDropdownVisible.set(false);
          navigate({ pathname: CHANGE_PASSWORD_PATH });
        }}
      />
      <ProfileAction
        icon={faRightFromBracket}
        label={i18n.get("SIGN_OUT")}
        labelColor={colors.all.red}
        restingBackground={PROFILE_DANGER_BACKGROUND}
        hoverBackground={PROFILE_DANGER_HOVER}
        border="0"
        onPress={() => getCoreLoginStore().signOutHandler()}
      />
    </ET3Div>
  );
});
export default ProfileDropdownButtons;
